module.exports = __webpack_public_path__ + "img/img3.c97b5f97.png";